import { Map } from 'immutable';

import { ApiActions } from '../../../constants/ApiActions';
import { StartupQueryParameterKeys } from '../../../constants/App';
import { createReducer, reduceReducers, transformDataReducer } from '../../../lib/ReducerUtils';
import { getUrlQueryParameters } from '../../../lib/utils/url';
import { IdleMonitorActions, IdleMonitorKeys, IdleMonitorStatuses } from '../constants/IdleMonitor';

export const INITIAL_STATE = Map({
  [IdleMonitorKeys.IS_RUNNING]: false,
  [IdleMonitorKeys.IDLE_STATUS]: IdleMonitorStatuses.ACTIVE,
  [IdleMonitorKeys.INACTIVE_TIMEOUT]: 90,
  [IdleMonitorKeys.ABANDONED_TIMEOUT]: 3600,
});

const QUERYSTRING_TRANSFORM = {
  [StartupQueryParameterKeys.INACTIVE_TIMEOUT]: IdleMonitorKeys.INACTIVE_TIMEOUT,
  [StartupQueryParameterKeys.ABANDONED_TIMEOUT]: IdleMonitorKeys.ABANDONED_TIMEOUT,
  [StartupQueryParameterKeys.TIMEOUT]: [
    IdleMonitorKeys.ABANDONED_TIMEOUT,
    IdleMonitorKeys.INACTIVE_TIMEOUT,
  ],
};

export default reduceReducers(
  transformDataReducer(getUrlQueryParameters, QUERYSTRING_TRANSFORM),
  createReducer(INITIAL_STATE, {
    [IdleMonitorActions.UPDATE]: update,
    [IdleMonitorActions.START]: start,
    [ApiActions.LOGIN_SUCCESS]: onLoginSuccess,
    [ApiActions.DEVICE_LOGIN_SUCCESS]: onLoginSuccess,
  }),
);

// CASE FUNCTIONS

function update(state, { payload }) {
  return state.set(IdleMonitorKeys.IDLE_STATUS, payload[IdleMonitorKeys.IDLE_STATUS]);
}

function start(state) {
  return state.set(IdleMonitorKeys.IS_RUNNING, true);
}

function onLoginSuccess(state, action) {
  const listenerId = (action && action.response && action.response.result) || null;
  return state.set(
    IdleMonitorKeys.ABANDONED_TIMEOUT,
    action.response.entities.listeners[listenerId].config.inactivityTimeout,
  );
}
